<div class="flex-container-column-center height-100 bg-auth-accent">
	<div class="width-100 flex-container-row-nowrap justify-content-space-between box-sizing-border-box">
		<button class="button-reset btn--text padding-16px color-light-gray-on-accent" (click)="cancel()">
			<i aria-hidden="true" class="fa fa-arrow-left"></i>
		</button>
		<ic-change-language class="margin-top-4px margin-right-8px color-light-gray-on-accent" />
	</div>
	<p class="text-align-center color-text margin-top-auto">
		{{ "auth.confirmPassword" | translate }}
	</p>
	<form novalidate [formGroup]="form">
		<fieldset>
			<ic-form-field
				fullErrorHeight
				[class.auth-new-password]="validationChecksState?.length <= 0"
				[class.auth-new-password-with-indicator]="validationChecksState?.length > 0"
				[hasError]="hasPasswordPolicyError()"
			>
				<span icLabel>
					{{ "auth.newPassword" | translate }}
				</span>

				<input
					data-test="new-password-input"
					formControlName="newPassword"
					icInput
					name="newPassword"
					type="password"
				/>

				<span class="fa fa-lock" icPrefix></span>

				@if (controlRequired("newPassword")) {
					<ic-error>
						{{ "auth.validators.password_required" | translate }}
					</ic-error>
				}
			</ic-form-field>

			@if (validationChecksState?.length > 0) {
				<div class="password-strength-indicator" data-test="password-strength-indicator">
					@for (check of validationChecksState; track check) {
						<div>
							<small [class.error]="!check?.active" [class.success]="check?.active">
								<i
									aria-hidden="true"
									class="fa"
									[class.fa-check-circle]="check?.active"
									[class.fa-times-circle]="!check?.active"
								></i>
								{{ "labels.error." + check?.key | translate: check }}
							</small>
						</div>
					}
				</div>
			}

			<ic-form-field>
				<span icLabel>
					{{ "auth.verifyPassword" | translate }}
				</span>

				<input
					data-test="confirm-password-input"
					formControlName="verifyPassword"
					icInput
					name="verifyPassword"
					type="password"
				/>

				<span class="fa fa-lock" icPrefix></span>

				@if (controlRequired("verifyPassword")) {
					<ic-error data-test="required-error">
						{{ "auth.validators.password_required" | translate }}
					</ic-error>
				}

				@if (!controlRequired("verifyPassword") && form.hasError("passwordsDoNoMatch")) {
					<ic-error data-test="invalid-match-error">
						{{ "auth.errors.match" | translate }}
					</ic-error>
				}
			</ic-form-field>

			<input type="submit" value="{{ 'auth.signin' | translate }}" (click)="confirm(form.value)" />
		</fieldset>
	</form>
	<div
		class="width-100 text-align-center font-size-0-8rem color-light-gray-on-accent margin-top-auto margin-bottom-1rem"
	>
		{{ "settings.version" | translate }} {{ appVersion }}
	</div>
</div>
